app.service('deliveryView', function(deliveryPoints, orderConfig, modal) {
	var config;

	function init(){
		setElements();
		setEvents();
		config = orderConfig.getData();
		if(config.deliveryType=='inpost' || config.deliveryType=='pickupPoints'){
			deliveryPoints.init();
			var $input = $('#zipCode');
			$input.on('blur', function () {				// nowy klient wpisuje kod pocztowy
				let value = $input.val();
				if (/^\d{2}-\d{3}$/.test(value)) {
					deliveryPoints.setZipCode(value);
				}
			});
		}
	}

	function setElements() {
	}

	function setEvents() {

	}

	return {
		init
	};
});